import React from "react";

const GithubIcon = ({ size = 16, ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0)">
        <path d="M15 0.625C6.71249 0.625 -7.62939e-06 7.225 -7.62939e-06 15.365C-7.62939e-06 21.8787 4.29749 27.4025 10.2562 29.35C11.0062 29.4887 11.2812 29.0325 11.2812 28.6413C11.2812 28.2913 11.2687 27.3638 11.2625 26.135C7.08999 27.0238 6.20999 24.1575 6.20999 24.1575C5.52749 22.4563 4.54124 22.0012 4.54124 22.0012C3.18249 21.0875 4.64624 21.1063 4.64624 21.1063C6.15249 21.2087 6.94374 22.625 6.94374 22.625C8.28124 24.8787 10.455 24.2275 11.3125 23.8512C11.4475 22.8975 11.8337 22.2487 12.2625 21.88C8.93124 21.5112 5.42999 20.2437 5.42999 14.5963C5.42999 12.9875 6.01124 11.6725 6.97374 10.6412C6.80499 10.2687 6.29874 8.77 7.10499 6.74C7.10499 6.74 8.36124 6.345 11.23 8.25125C12.43 7.92375 13.705 7.76125 14.98 7.75375C16.255 7.76125 17.53 7.92375 18.73 8.25125C21.58 6.345 22.8362 6.74 22.8362 6.74C23.6425 8.77 23.1362 10.2687 22.9862 10.6412C23.9425 11.6725 24.5237 12.9875 24.5237 14.5963C24.5237 20.2588 21.0175 21.505 17.68 21.8675C18.205 22.31 18.6925 23.2138 18.6925 24.595C18.6925 26.5675 18.6737 28.1525 18.6737 28.6313C18.6737 29.0175 18.9362 29.4788 19.705 29.3312C25.7062 27.3962 30 21.8687 30 15.365C30 7.225 23.2837 0.625 15 0.625Z" />
      </g>
    </svg>
  );
};

export default GithubIcon;
